import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { StorageService } from '../_services/storage.service';
import { AuthService } from '../components/auth/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    providers: [DatePipe]
})
export class AppTopbarComponent implements OnInit {
    
    @ViewChild('menubutton') menuButton!: ElementRef
    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent

    userName: string = ''
    userMail: string = ''
    userSub: string = ''
    userRole: string = ''
    employeeId: number = 0
    isDialogEdit: boolean = false
    userForm!: FormGroup
    env: boolean = false
    todayDate: string = ''

    constructor(
        public layoutService: LayoutService, 
        public el: ElementRef,
        private storageService: StorageService,
        private authService: AuthService,
        private datePipe: DatePipe
    ) {}

    ngOnInit(): void {
        this.env = environment.production
        if (this.storageService.getUser()) {
            this.userName = this.storageService.getUser().profile.name
            this.userMail = this.storageService.getUser().profile.email
            this.userSub = this.storageService.getUser().profile.sub
            this.userRole = this.storageService.getUser().profile.role
            this.employeeId = this.storageService.getUser().employee_id
        }

        this.userForm = new FormGroup({
            id: new FormControl(this.userSub),
            name: new FormControl(this.userName),
            email: new FormControl(this.userMail),
            role: new FormControl(this.userRole),
            password: new FormControl('', [Validators.required]),
            passwordConfirm: new FormControl('', [Validators.required])
        })

        setInterval(() => {
            this.startTime()
        }, 100)

    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle()
    }

    onProfileButtonClick() {
        this.layoutService.showRightMenu()
    }

    onSearchClick() {
        this.layoutService.toggleSearchBar()
    }

    onRightMenuClick() {
        this.layoutService.showRightMenu()
    }

    onProfileClick() {
        this.isDialogEdit = true
    }

    get logo() {
        const logo =
            this.layoutService.config().menuTheme === 'white' ||
            this.layoutService.config().menuTheme === 'orange'
                ? 'dark'
                : 'white';
        return logo
    }

    logout(): void {
        this.authService.logout(this.storageService.getUser().id_token).catch(err => console.log(err))
    }

    startTime() {
        const today = new Date()
        let h = today.getHours()
        let m = today.getMinutes()
        let s = today.getSeconds()
        this.todayDate = this.datePipe.transform(new Date(), 'EEEE, dd/MM/yyyy')! + ' ' + this.checkTime(h) + ':' + this.checkTime(m) + ':' + this.checkTime(s)
    }

    checkTime(i: any) {
        if (i < 10) { i = "0" + i; }
        return i;
    }

}
